// @flow
import * as React from 'react';

import styles from './CommentString.module.scss';;


type Props = {
  children?: React.Node,
  className?: string,
}

const CommentString = ({ children }: Props) => (
  <div className={styles.root}>{children}</div>
);

export default CommentString;
